/**
 * @module Plans Pricing
 * @description
 */
import Head from 'next/head';

// Template
import Template from '@/templates/Default';

// Blocks
import BannerServiceCheck from '@/blocks/Banners/BannerServiceCheck';
import HeroPricePoint from '@/blocks/Heroes/HeroPricePoint';
import BannerList from '@/blocks/Banners/BannerList';
import ComparisonGrid from '@/blocks/ComparisonGrid';
import BannerCTA from '@/blocks/Banners/BannerCTA';

const location = 'PLANS PRICING';

/**
 * @function Page
 * @description
 */
const Page = () => (
  <>
    <Head>
      <title>Plans Pricing | FrontierInternet</title>
    </Head>

    <Template
        title="Plans Pricing"
        hero={
          <>
            <BannerServiceCheck />

            <HeroPricePoint
              headline={ <>Better <span>faster</span> <span key="span-1" className='u-color-blue'>100% FIBER</span></> }
              location={ location }
              background="hero-man-wearing-vr"
              useSelectAreasLegal
            />
          </>
        }
        primary={
          <>
            <BannerList
              theme="blue"
              items={ [
                {
                  copy: 'For smart homes with dozens of devices',
                  icon: 'checkmark1'
                },
                {
                  copy: <>$10/mo. off YouTube TV for one year<span data-legal="youtubetv" /></>,
                  icon: 'checkmark1'
                },
                {
                  copy: <>Amazon eero Pro 6 Wi-Fi router<span data-legal="eero" /></>,
                  icon: 'checkmark1'
                }
              ] }
            />

            <ComparisonGrid />

            <BannerCTA
              copy="Ready to see internet plans available in your neighborhood?"
              location={ location }
            />
          </>
        }
    />
  </>
);

export default Page;
